import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Style/CreateTask.css";
import "../Style/NewCustomer.css";
import MainSidebar from "./Mainsidebar";
import UserNavbar from "./UserNavbar";
import UserFooter from "./UserFooter";
import { path_url } from "../Config/config";
import countryData from "../Utils/countryData.json";

// Options matching backend enums/dropdowns for Settings
const TIMEZONE_OPTIONS = [
  "UTC_MINUS_12",
  "UTC_MINUS_11",
  "UTC_MINUS_10",
  "UTC_MINUS_9",
  "UTC_MINUS_8",
  "UTC_MINUS_7",
  "UTC_MINUS_6",
  "UTC_MINUS_5",
  "UTC_MINUS_4",
  "UTC_MINUS_3_30",
  "UTC_MINUS_3",
  "UTC_MINUS_2",
  "UTC_MINUS_1",
  "UTC",
  "UTC_PLUS_1",
  "UTC_PLUS_2",
  "UTC_PLUS_3",
  "UTC_PLUS_3_30",
  "UTC_PLUS_4",
  "UTC_PLUS_4_30",
  "UTC_PLUS_5",
  "UTC_PLUS_5_30",
  "UTC_PLUS_5_45",
  "UTC_PLUS_6",
  "UTC_PLUS_6_30",
  "UTC_PLUS_7",
  "UTC_PLUS_8",
  "UTC_PLUS_9",
  "UTC_PLUS_9_30",
  "UTC_PLUS_10",
  "UTC_PLUS_11",
  "UTC_PLUS_12",
  "UTC_PLUS_13",
  "UTC_PLUS_14",
  "PST",
  "MST",
  "CST",
  "EST",
  "GMT",
  "CET",
  "EET",
  "JST",
  "AEDT",
  "AEST",
  "ACST",
  "NZDT",
  "NZST",
];

const customerSchema = Yup.object().shape({
  role: Yup.string().required("Role is required"),
  company: Yup.string().required("Company is required"),
});

export default function Setting() {
  const navigate = useNavigate();
  const [hamburger, sethamburger] = useState(true);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [dbValues, setDbValues] = useState(null); // values loaded from DB

  // Load settings from database on component mount
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const adminId = localStorage.getItem("adminId");
        if (!token || !adminId) return;

        // GET /user returns the logged-in user's full profile
        const response = await axios.get(`${path_url}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = response?.data;
        if (data) {
          const loaded = {
            role:
              data.designation || localStorage.getItem("mySettingRole") || "",
            company:
              data.companyName ||
              localStorage.getItem("mySettingCompany") ||
              "",
            workDate: "",
            region:
              data.country || localStorage.getItem("mySettingRegion") || "",
            language: data.language || "",
            timeZone:
              data.timezone || localStorage.getItem("mySettingTimeZone") || "",
            notification: "",
            technicalTips: false,
          };
          // setDbValues(loaded);
          // Update localStorage cache
          localStorage.setItem("mySettingRole", loaded.role);
          localStorage.setItem("mySettingCompany", loaded.company);
          localStorage.setItem("mySettingRegion", loaded.region);
          localStorage.setItem("mySettingTimeZone", loaded.timeZone);
        }
      } catch (err) {
        // If fetch fails, fall back to localStorage (already in initialValues)
        console.warn(
          "Could not load settings from DB:",
          err?.response?.data || err.message,
        );
      }
    };
    fetchSettings();
  }, []);
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const Priority = [
    { value: "High" },
    { value: "Medium" },
    { value: "Low" },
    { value: "Critical" },
    { value: "Normal" },
    { value: "Emergency" },
    { value: "Deferred" },
  ];

  const Enum = [
    { value: "English" },
    { value: "Hindi" },
    { value: "Spanish" },
    { value: "French" },
    { value: "German" },
    { value: "Chinese" },
  ];
  return (
    <div className="con1 d-flex">
      <div className="subcon1" style={handleclickonbutton1(hamburger)}>
        <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
      </div>
      <div className="subcon2" style={handleclickonbutton(hamburger)}>
        <UserNavbar
          hamburger={hamburger}
          sethamburger={sethamburger}
          handelRightMenuShow={handelRightMenuShow}
          handelShow={handelShow}
          isSearchShow={isSearchShow}
          handleScreenEnter={handleScreenEnter}
          handleScreenExit={handleScreenExit}
          fullScreen={fullScreen}
        />
        <div className="mt-2 min-vh-100">
          <Formik
            initialValues={{
              role: "",
              company: "",
              workDate: "",
              region: "",
              language: "",
              timeZone: "",
              notification: "",
              technicalTips: false,
            }}
            enableReinitialize={false}
            validationSchema={customerSchema}
            onSubmit={async (values) => {
              try {
                const token = localStorage.getItem("accessToken");
                const adminId = localStorage.getItem("adminId");
                const userId = localStorage.getItem("userId");

                if (!token || !adminId) {
                  toast.error("Authentication missing. Please log in again.");
                  return;
                }

                // Use PUT /users to update the user's profile in the database
                const payload = {
                  id: userId,
                  adminid: adminId,
                  designation: values.role,
                  companyName: values.company,
                  country: values.region,
                  timezone: values.timeZone || null,
                  name: localStorage.getItem("name") || "",
                };

                const response = await axios.put(`${path_url}/users`, payload, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                });

                if (
                  response?.status === 200 ||
                  response?.data?.statusCodeValue === 200
                ) {
                  // Update localStorage cache
                  localStorage.setItem("mySettingRole", values.role);
                  localStorage.setItem("mySettingCompany", values.company);
                  localStorage.setItem("mySettingRegion", values.region);
                  localStorage.setItem("mySettingTimeZone", values.timeZone);
                  toast.success("Settings saved to database successfully!");
                } else {
                  toast.error(
                    response?.data?.body || "Failed to save settings.",
                  );
                }
              } catch (error) {
                console.error("Save settings error:", error);
                // Fall back: still save to localStorage
                localStorage.setItem("mySettingRole", values.role);
                localStorage.setItem("mySettingCompany", values.company);
                localStorage.setItem("mySettingRegion", values.region);
                localStorage.setItem("mySettingTimeZone", values.timeZone);
                toast.warning(
                  "Saved locally. Backend error: " +
                    (error?.response?.data?.message ||
                      error?.response?.data ||
                      error.message),
                );
              }
            }}
          >
            {(formik) => (
              <form action="" onSubmit={formik.handleSubmit}>
                <fieldset>
                  <div className="col-12 d-flex justify-content-center">
                    <div className="bg-white col-11 cont">
                      <div className="d-flex  mb-4">
                        <div
                          style={{ color: "gray" }}
                          className=" col-12 m-1 mt-2 rounded shadow-sm elevation-2 pt-1"
                        >
                          <p className="text-white p-1 m-0">
                            <strong>My Settings</strong>
                          </p>
                        </div>
                      </div>
                      {/* <div className="border col-11 mt-1 ml-5 "></div> */}

                      <div className="d-flex flex-wrap">
                        <div className="col-12 col-md-6 pl-0 pr-0">
                          <div className="col-12 col-sm-12 d-flex  mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Role</strong>
                                <sup
                                  style={{
                                    color: "red",
                                    top: 0,
                                    fontSize: 15,
                                    lineHeight: 0,
                                    position: "relative",
                                    verticalAlign: "baseline",
                                  }}
                                >
                                  *
                                </sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                placeholder="Enter your role"
                                name="role"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.role}
                              />
                              {formik.touched.role && formik.errors.role && (
                                <small style={{ color: "red" }}>
                                  {formik.errors.role}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-sm-12 d-flex  mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Company</strong>
                                <sup
                                  style={{
                                    color: "red",
                                    top: 0,
                                    fontSize: 15,
                                    lineHeight: 0,
                                    position: "relative",
                                    verticalAlign: "baseline",
                                  }}
                                >
                                  *
                                </sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                placeholder="Enter your company"
                                name="company"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.company}
                              />
                              {formik.touched.company &&
                                formik.errors.company && (
                                  <small style={{ color: "red" }}>
                                    {formik.errors.company}
                                  </small>
                                )}
                            </div>
                          </div>
                          <div className="col-12 col-sm-12 d-flex  mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Work Date:</strong>
                                <sup
                                  style={{
                                    color: "red",
                                    top: 0,
                                    fontSize: 15,
                                    lineHeight: 0,
                                    position: "relative",
                                    verticalAlign: "baseline",
                                  }}
                                >
                                  *
                                </sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 d-flex  ">
                              <div
                                className="col-12 m-0"
                                style={{
                                  paddingLeft: "2px",
                                  paddingRight: "0px",
                                }}
                              >
                                <div className="p-0 m-0 w-100  forms ">
                                  <input
                                    className="input-field date "
                                    type="date"
                                    placeholder=""
                                    name="workDate"
                                    value={formik.values.workDate}
                                    onChange={formik.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Region</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field
                                as="select"
                                name="region"
                                id="region"
                                className="selectBox custom-select "
                              >
                                <option value="">Select Region</option>
                                {countryData.countries.map((country, i) => (
                                  <option key={i} value={country.country_name}>
                                    {country.country_name}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>
                          <div className="col-12 col-sm-12 d-flex  mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Language</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field
                                as="select"
                                name="language"
                                id="language"
                                className="selectBox custom-select "
                              >
                                <option value="">Select Language</option>
                                {Enum.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.value}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>
                          {/* <div className="border col-12 ml-1 mb-3"></div> */}
                        </div>

                        <div className="col-12 col-md-6 pl-0 pr-0">
                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg ">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Time Zone </strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field
                                as="select"
                                name="timeZone"
                                id="timeZone"
                                className="selectBox custom-select "
                              >
                                <option value="">Select Time Zone</option>
                                {TIMEZONE_OPTIONS.map((tz) => (
                                  <option key={tz} value={tz}>
                                    {tz.replace(/_/g, " ")}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2 pt-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg ">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Technical Tips </strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <div className="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customSwitches"
                                  name="technicalTips"
                                  checked={formik.values.technicalTips}
                                  onChange={formik.handleChange}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customSwitches"
                                ></label>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-12 d-flex pt-4">
                            <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                              <button
                                type="button"
                                className="btn btn-sm bg-white text-dark border rounded border-gray"
                                onClick={() => formik.resetForm({
                                  values: {
                                    role: "",
                                    company: "",
                                    workDate: "",
                                    region: "",
                                    language: "",
                                    timeZone: "",
                                    notification: "",
                                    technicalTips: false,
                                  }
                                })}
                              >
                                Cancel
                              </button>
                            </div>
                            <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                              <button
                                type="submit"
                                className="btn btn-sm bg-white text-dark border rounded border-gray"
                              >
                                Save
                              </button>
                            </div>
                          </div>

                          {/* <div className="border col-12 ml-1 mb-3"></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            )}
          </Formik>
        </div>
        <UserFooter />
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </div>
  );
}
